import { combineApiConfigs, createMetroApiConfig, QueryConfigTypes } from '@wix/premium-fed-sdk/@apis-infra';
import { WixWarApiConfig } from './WixWarApiConfig';
import { RawHttpApiConfig } from './RawHttpApiConfig';
import { DomainsServerlessApiConfig } from './DomainsServerlessApiConfig';
import { DomainsDnsApiConfig } from './DomainsDnsApiConfig';
import { checkDomainAvailability } from '@wix/ambassador-premium-domains-v2-availability/http';
import { suggestDomains } from '@wix/ambassador-premium-domains-v2-suggestion/http';
import { createConnectedDomain, getConnectedDomain, deleteConnectedDomain, listConnectedDomains } from '@wix/ambassador-premium-domains-v1-connected-domain/http';
import { createSku, getSku, listSkus, deleteSku, updateSku } from '@wix/ambassador-premium-domains-v1-sku/http';
import { getConnectedDomainSetupInfo, getSetupInfo, getMxRecords } from '@wix/ambassador-premium-domains-v1-connected-domain-setup-info/http';
import { getDomainPrice, listDomainPrice, getPremiumDomainPrice } from '@wix/ambassador-premium-domains-v1-domain-price/http';
import { createInsight, deleteInsight, queryInsight, queryInsightSummary, updateInsight } from '@wix/ambassador-genie-v1-insight/http';
import { createConversation, getConversationMessages, getConversations, getTextToSpeech, sendMessage } from '@wix/ambassador-genie-chat-service-v1-no-entity/http';
import { getMyMetaSiteProfile, getMyUserProfile, getProfile } from '@wix/ambassador-data-services-profile-client-v4-profile-field-data/http';
import { bindDomain, bindMultipleDomains, getSite, listAssignedDomains, listSites, listUnassignedDomains, unbindDomain } from '@wix/ambassador-domains-mydomains-v1-domain/http';
import { listRecommendations } from '@wix/ambassador-premium-domains-v1-recommendation/http';
import { approveTransfer } from '@wix/ambassador-premium-domains-v1-registered-domain/http';
import { generateBusinessNames } from '@wix/ambassador-premium-domains-v1-business-name-generator/http';
import { getInsight, listInsights, matchLabels } from '@wix/ambassador-premium-domains-v1-insight/http';
import { listDisplayPrices } from '@wix/ambassador-premium-domains-v1-display-price/http';
import { listTldPromotions } from '@wix/ambassador-premium-domains-v1-tld-promotion/http';
import { listKeywords } from '@wix/ambassador-premium-domains-v1-keyword/http';
import { listUkIpsTags } from '@wix/ambassador-premium-domains-v1-ips-tag/http';
import { previewDomainRegistrationIntent, upsertDomainRegistrationIntent } from '@wix/ambassador-premium-domains-v1-domain-registration-intent/http';
import { getAllowedCycle } from '@wix/ambassador-premium-domains-v1-allowed-cycle/http';
import { listEligibleCoupons } from '@wix/ambassador-premium-domains-v1-eligible-coupon/http';
import { validateAuthorizationCode, validateDomainTransferability } from '@wix/ambassador-premium-domains-v1-domain-transfer-in-validation-result/http';
import { getRdapUrl, whoisLookup, parseRdap, proxyRdap } from '@wix/ambassador-premium-domains-v1-structured-domain-info/http';
import { createDomainAssignment, getDomainAssignment, setDomainAsPrimary, reassignDomain, deleteDomainAssignment, listDomainAssignments, restoreDomainAssignment, upsertDomainAssignment } from '@wix/ambassador-premium-domains-v1-domain-assignment/http';
export const DomainsProtoApisConfig = combineApiConfigs(createMetroApiConfig({
  validateAuthorizationCode,
  validateDomainTransferability,
  listEligibleCoupons,
  listUkIpsTags,
  previewDomainRegistrationIntent,
  upsertDomainRegistrationIntent,
  getAllowedCycle,
  getConnectedDomainSetupInfo,
  getSetupInfo,
  getMxRecords,
  checkDomainAvailability,
  createInsight,
  deleteInsight,
  queryInsight,
  queryInsightSummary,
  updateInsight,
  createConversation,
  getConversationMessages,
  getConversations,
  getTextToSpeech,
  sendMessage,
  getMyMetaSiteProfile,
  getMyUserProfile,
  getProfile,
  bindDomain,
  bindMultipleDomains,
  getSite,
  listAssignedDomains,
  listSites,
  listUnassignedDomains,
  unbindDomain,
  listRecommendations,
  generateBusinessNames,
  getInsight,
  listInsights,
  matchLabels,
  listDisplayPrices,
  listTldPromotions,
  listKeywords,
  getRdapUrl,
  whoisLookup,
  parseRdap,
  proxyRdap,
  createDomainAssignment,
  getDomainAssignment,
  setDomainAsPrimary,
  reassignDomain,
  deleteDomainAssignment,
  listDomainAssignments,
  restoreDomainAssignment,
  upsertDomainAssignment,
  approveTransfer
}), createMetroApiConfig({
  suggestDomains
}), createMetroApiConfig({
  createConnectedDomain,
  getConnectedDomain,
  deleteConnectedDomain,
  listConnectedDomains
}, {
  methodsOptions: {
    createConnectedDomain: {
      queryConfigType: QueryConfigTypes.REALTIME_NO_REFETCH
    }
  }
}), createMetroApiConfig({
  createSku,
  getSku,
  listSkus,
  deleteSku,
  updateSku
}, {
  serviceOptions: {
    defaultQueryConfigType: QueryConfigTypes.MODERATE_DATA
  }
}), createMetroApiConfig({
  getDomainPrice,
  listDomainPrice,
  getPremiumDomainPrice
}, {
  methodsOptions: {
    getDomainPrice: {
      queryConfigType: QueryConfigTypes.STATIC_DATA
    },
    listDomainPrice: {
      queryConfigType: QueryConfigTypes.STATIC_DATA
    }
  }
}));
export const DomainsApiConfig = combineApiConfigs(WixWarApiConfig, RawHttpApiConfig, DomainsDnsApiConfig, DomainsServerlessApiConfig, DomainsProtoApisConfig);
//# sourceMappingURL=DomainsApiConfig.js.map